import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import GoogleAnalytics from '@/components/common/analytics/GoogleAnalytics';
import GoogleTagManager from '@/components/common/analytics/GoogleTagManager';
import { ConfirmModalProvider } from '@/contexts/ConfirmModalContext';
import { ModalProvider } from '@/contexts/ModalContext';
import { DrawerProvider } from '@/contexts/DrawerContext';
import { SdHeaderMenuDrawerProvider } from '@/contexts/SdHeaderMenuDrawerContext';
import { TacticalboardDrawerProvider } from '@/contexts/TacticalboardDrawerContext';
import { ToastProvider } from '@/contexts/ToastContext';
import { NotificationProvider } from '@/contexts/NotificationContext';
import { GlobalContextProvider } from '@/contexts/GlobalContext';
import AppLayout from '@/app/AppLayout';

/**
 * NOTE: z-index
 * 当アプリケーションではモーダル＆ドロワーを多用して画面間を行き来する仕様なのでz-indexを意識して実装する必要がある
 *
 * 現在の最大のネストパターン:
 *  base(ページ) -> drawer(サッカーノート等の入力フォーム) -> modal（my board） -> tacticalboard drawer -> confirm modal
 *
 * z-0(設定なし): base(ページ)
 * z-10: sdヘッダードロワー(プロフィールカード)
 * z-20: アプリケーションドロワー（サッカーノート入力、目標入力、コメント入力など）
 * z-30: アプリケーションモーダル（my board、拡大画像など）
 * z-40: サッカーボードドロワー
 * z-50: 確認ダイアログ（モーダル）
 *
 * ※ z-xx はtailwindのユーティリティークラスであり、現状は元々良いされているユーティリティークラスz-50までに収まっている。
 * これ以上増える場合、CSSフレームワーク思想から逸脱することになる（50まで用意していないということはUX的な観点でこの範囲に収めるのが好ましい？）
 * のでその際はその時の技術トレンド等見極めて適切に設計すること
 */
function App() {
  const location = useLocation();

  // 画面遷移後、最上部を表示する
  // NOTE: 遷移前のスクロール位置がブラウザの動作として保存されてしまう場合がある。
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <GoogleAnalytics />
      <GoogleTagManager />
      <GlobalContextProvider>
        <ToastProvider>
          <ConfirmModalProvider>
            <TacticalboardDrawerProvider>
              <ModalProvider>
                <NotificationProvider>
                  <SdHeaderMenuDrawerProvider>
                    <DrawerProvider>
                      <AppLayout>
                        <Outlet />
                      </AppLayout>
                    </DrawerProvider>
                  </SdHeaderMenuDrawerProvider>
                </NotificationProvider>
              </ModalProvider>
            </TacticalboardDrawerProvider>
          </ConfirmModalProvider>
        </ToastProvider>
      </GlobalContextProvider>
    </>
  );
}

export default App;
